import React, { useRef } from 'react';
import { FaBuilding, FaMapPin, FaPhone, FaMobileAlt, FaEnvelope } from 'react-icons/fa';

const Contact = () => {
  const formRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    const btn = e.target.querySelector('.btn-primary');
    const original = btn.innerHTML;
    btn.innerHTML = '<span class="btn-content">✓ Sent!</span>';
    btn.style.background = 'linear-gradient(135deg, #4ade80, #22c55e)';
    setTimeout(() => {
      btn.innerHTML = original;
      btn.style.background = '';
      e.target.reset();
    }, 2500);
  };

  return (
    <section className="contact-preview" id="contact">
      <div className="container">
        <div className="contact-card reveal">
          <h3>Get in Touch</h3>
          <p className="sub">Reach out to our team for wholesale inquiries and global supply solutions.</p>

          <div className="contact-item">
            <div className="icon-wrapper"><FaBuilding /></div>
            <div className="info">
              <div className="label">Company</div>
              <div className="value">AUTO EXPERTS FZE</div>
            </div>
          </div>
          <div className="contact-item">
            <div className="icon-wrapper"><FaMapPin /></div>
            <div className="info">
              <div className="label">Address</div>
              <div className="value">Jebel Ali Free Zone, Dubai, United Arab Emirates</div>
            </div>
          </div>
          <div className="contact-item">
            <div className="icon-wrapper"><FaPhone /></div>
            <div className="info">
              <div className="label">Phone / WhatsApp</div>
              <div className="value"><a href="tel:+447774106350">+44 7774 106350</a></div>
            </div>
          </div>
          <div className="contact-item">
            <div className="icon-wrapper"><FaMobileAlt /></div>
            <div className="info">
              <div className="label">UAE Phone</div>
              <div className="value"><a href="tel:+971508719109">+971 50 871 9109</a></div>
            </div>
          </div>
          <div className="contact-item">
            <div className="icon-wrapper"><FaEnvelope /></div>
            <div className="info">
              <div className="label">Email</div>
              <div className="value"><a href="mailto:ameer.94ir@gmail.com">ameer.94ir@gmail.com</a></div>
            </div>
          </div>

          <div className="map-placeholder">📍 Jebel Ali Free Zone · Dubai</div>
        </div>

        <div className="contact-form reveal reveal-delay-1">
          <h3>Send an Inquiry</h3>
          <form ref={formRef} onSubmit={handleSubmit} noValidate>
            <div className="form-group">
              <label htmlFor="name">Full Name</label>
              <input type="text" id="name" placeholder="Your full name" required />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input type="email" id="email" placeholder="you@company.com" required />
            </div>
            <div className="form-group">
              <label htmlFor="phone">Phone Number</label>
              <input type="tel" id="phone" placeholder="+971 50 123 4567" />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea id="message" placeholder="Tell us about your wholesale requirements..." rows="4"></textarea>
            </div>
            <div className="form-group">
              <button type="submit" className="btn-primary">
                <span className="btn-content">
                  Send Inquiry
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12" />
                    <polyline points="12 5 19 12 12 19" />
                  </svg>
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;